"use client";

import { Check } from "lucide-react";
import { Checkbox as RadixCheckbox } from "radix-ui";
import type { ComponentPropsWithRef } from "react";

import { cn } from "@/services/styles/cn";

const { Root, Indicator } = RadixCheckbox;

export interface CheckboxProps extends ComponentPropsWithRef<typeof Root> {}

export function Checkbox({ className, ...props }: CheckboxProps) {
  return (
    <Root
      className={cn(
        "peer size-4 shrink-0 rounded-xs border border-primary ring-offset-background",
        "focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
        className,
      )}
      {...props}
    >
      <Indicator className={cn("flex items-center justify-center text-current")}>
        <Check className="size-4" />
      </Indicator>
    </Root>
  );
}
